'use client'

import { AccountDrawer } from '@/feature/account/components/account-drawer/AccountDrawer.client'
import { needsPickupPointOfSale } from '@/feature/account/services/account.routing'
import { SignedInCartDrawer } from '@/feature/cart/components/signed-in-cart-drawer/SignedInCartDrawer.client'
import { SignedOutCartDrawer } from '@/feature/cart/components/signed-out-cart-drawer/SignedOutCartDrawer.client'
import {
  isCheckoutConfirmationPath,
  isCheckoutPath,
  isEmptyCartPath,
} from '@/feature/checkout/services/checkout.routing'
import { PointOfSaleDrawer } from '@/feature/point-of-sale/components/drawers/point-of-sale-drawer/PointOfSaleDrawer.client'
import { SelectFavoritePointOfSaleDrawer } from '@/feature/point-of-sale/components/drawers/select-favorite-point-of-sale-drawer/SelectFavoritePointOfSaleDrawer.client'
import { SelectPickupPointOfSaleDrawer } from '@/feature/point-of-sale/components/drawers/select-pickup-point-of-sale-drawer/SelectPickupPointOfSaleDrawer.client'
import { EquivalentProductsDrawer } from '@/feature/product/components/equivalent-products/EquivalentProductsDrawer.client'
import { usePathname } from 'next/navigation'

export function HeaderDrawers() {
  const pathname = usePathname()
  const isCheckout = isCheckoutPath(pathname)
  const isConfirmationPage = isCheckoutConfirmationPath(pathname)
  const isEmptyCartPage = isEmptyCartPath(pathname)
  const isCheckoutSteps = isCheckout && !isConfirmationPage && !isEmptyCartPage

  /**
   *  Remove drawers from login page + login error pages, account selection, creation,
   *  point of sale selection and all authentication/technical pages using simplified header
   */
  const needsPickupPos = needsPickupPointOfSale(pathname)

  if (isCheckoutSteps || !needsPickupPos) return

  return (
    <>
      <AccountDrawer />
      <PointOfSaleDrawer />
      <SelectFavoritePointOfSaleDrawer />
      <SelectPickupPointOfSaleDrawer />

      <SignedInCartDrawer />
      <SignedOutCartDrawer />

      <EquivalentProductsDrawer />
    </>
  )
}
